import {
  styled,
  Box,
  Typography,
  Popper,
  Divider,
  MenuItem,
} from "@mui/material";
import { Avatar } from "../../Avatar";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

export const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  marginRight: "5px",
}));

export const UserDataWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const UserDataName = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "14px",
  textAlign: "right",
}));

export const UserDataPosition = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "12px",
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: "32px",
  height: "32px",
  marginLeft: "5px",
}));

export const StyledAccountIcon = styled(AccountCircleOutlinedIcon)(
  ({ theme }) => ({
    width: "32px",
    height: "32px",
    color: theme.palette.success.main,
    marginLeft: "5px",
  })
);

export const StyledPopper = styled(Popper)(({ theme }) => ({
  zIndex: 999,
  marginTop: "12px",
}));

export const StyledPopperBox = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  paddingTop: "10px",
  backgroundColor: theme.palette.primary.dark || "#012A2D",
  width: "300px",
  position: "relative",
}));

export const PopperArrow = styled("span")(({ theme }) => ({
  position: "absolute",
  top: "-5px",
  right: "10px",
  width: 0,
  height: 0,
  borderLeft: "8px solid transparent",
  borderRight: "8px solid transparent",
  borderBottom: `8px solid ${theme.palette.primary.dark}`,
}));

export const NameText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "12px",
  padding: "5px 15px 5px 15px",
  fontWeight: 600,
}));

export const EmailText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "14px",
  padding: "5px 15px 5px 15px",
  fontWeight: 500,
}));

export const RoleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "12px",
  padding: "5px 15px 0px 15px",
}));

export const CompanyName = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "12px",
  padding: "5px 15px 10px 15px",
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
}));

export const StyledMenuItemTop = styled(MenuItem)(({ theme }) => ({
  padding: "15px 15px 8px 15px",
  backgroundColor: theme.palette.primary.dark,
  fontSize: "12px",
}));

export const StyledMenuItemBottom = styled(MenuItem)(({ theme }) => ({
  padding: "8px 15px 15px 15px",
  backgroundColor: theme.palette.primary.dark,
  fontSize: "12px",
}));
